import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logTrackingEvent } from '@/services/trackingService';
import { isTrackingEnabled } from '@/services/trackingSettingsService';

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

/**
 * Hook to track PageView events on route changes for Meta Pixel and Google Analytics
 * This is essential for Single Page Applications (SPA) like React
 * to ensure each page navigation is tracked properly.
 */
export const usePageViewTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const trackPageView = async () => {
      // Check if tracking is enabled
      const trackingEnabled = await isTrackingEnabled();
      if (!trackingEnabled) {
        console.log('PageView tracking skipped: tracking disabled');
        return;
      }

      // Track Meta Pixel PageView
      if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('track', 'PageView');
        console.log('Meta Pixel PageView tracked for:', location.pathname);
      }

      // Track Google Analytics page_view
      if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', 'page_view', {
          page_path: location.pathname,
          page_location: window.location.href,
          page_title: document.title
        });
        console.log('GA4 page_view tracked for:', location.pathname);
      }
      
      // Log to PocketBase tracking
      logTrackingEvent({
        event_type: 'PageView',
        event_id: `PageView_${Date.now()}`,
        page_url: window.location.href,
        source: 'browser',
        metadata: { pathname: location.pathname }
      });
    };

    trackPageView();
  }, [location.pathname]);
};
